import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Icon from '../icon/icon';

const SocialAccountsQuery = graphql`
    query SocialAccountsQuery {
        global: datoCmsGlobalSiteSetting {
            facebookAccount
            twitterAccount
            linkedinAccount
        }
    }
`;

// eslint bug
/* eslint-disable react/prop-types */
const SocialIcons = ({ className }: React.HTMLAttributes<HTMLSpanElement>): React.ReactElement => {
    const { global } = useStaticQuery(SocialAccountsQuery);

    return (
        <span className={'flex space-x-6 '.concat(className || '')}>
            <a href={`https://www.facebook.com/${global.facebookAccount}`} title="Facebook">
                <Icon name="facebook" className="fill-current hover:text-secondary" style={{ height: '1.5em', width: '1.5em' }} />
            </a>
            <a href={`https://www.twitter.com/${global.twitterAccount}`} title="Twitter">
                <Icon name="twitter" className="fill-current hover:text-secondary" style={{ height: '1.5em', width: '1.5em' }} />
            </a>
            <a href={`https://www.linkedin.com/company/${global.linkedinAccount}`} title="LinkedIn">
                <Icon name="linkedin" className="fill-current hover:text-secondary" style={{ height: '1.5em', width: '1.5em' }} />
            </a>
        </span>
    );
};

export default SocialIcons;
